'use client';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PropsWithChildren } from 'react';
import { getQueryClient } from '@/shared/api/query-client';

export const QueryClientProvider = ({ children }: PropsWithChildren) => {
    const queryClient = getQueryClient();

    return (
        <TanstackQueryClientProvider client={queryClient}>
            {children}
            {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
        </TanstackQueryClientProvider>
    );
};
